const Dashboard = () => import("../layouts/dashboard.vue");
const UserProfile = () => import("../pages/user/userProfile.vue");

/**
 * @type {import('vue-router').RouteConfig[]}
 */
export const userRoutes = [
  {
    path: "/user",
    component: Dashboard,
    meta: { requiresAuth: true },
    redirect: "/perfil",
    children: [
      {
        path: "perfil",
        component: UserProfile,
      },
    ],
  },
];
